import React from "react";
import { CreditState } from "../../../stores/credit/credit-state.interface";
import { useCreditSelector } from "../../../stores/product/product.store";
import { Sbox } from "./methods/Sbox";
import { Rr } from "./methods/Rr";
import { Llu } from "./methods/Llu";
import { Onp } from "./methods/Onp";
import Mpp from "./methods/Mpp";

export const ShippingForm: React.FC = () => {
    const method = useCreditSelector((state: CreditState) => state.shipping.selectShippingMethod);

    return (
        <>
            { method && <div>
                { method?.code === '_RR_' && <Rr pickups={ method && method.pickups ? method.pickups : [] } /> }
                { method?.code === '_LLU_' && <Llu zones={ method && method.zones ? method.zones : [] } /> }
                { method?.code === '_ONP_' && <Sbox /> }
                { method?.code === '_SBOX_' && <Onp /> }
                { method?.code === '_MPP_' && <Mpp pickups={ method && method.pickups ? method.pickups : [] } additionalText={ method.additionalText } /> }
                </div>
            }
        </>
    )
}